import { OmCheckBox, OmFindAnAdviser } from '@om/component-library-react';
import {
    setAssistanceTypeValue,
    setChosenLatValue,
    setChosenLongValue,
    setDiscussionOptionsSelectedValue,
    setLocationEnabledValue,
    setLocationTypeValue,
    setTestedLocationStatusValue,
} from '@om/redux/actions/publicWeb/findAnAdvisor';
import {
    getAssistanceType,
    getChosenLat,
    getChosenLong,
    getDiscussionOptionsSelected,
    getLocationEnabled,
    getLocationType,
    getSearchCriteria,
    getTestedLocationStatus,
} from '@om/redux/selectors/publicWeb/findAnAdvisor';
import React from 'react';
import Autocomplete from 'react-google-autocomplete';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ThemeContext } from '../context/ThemeContext';
import OmButton from './forms/OmButton';
import OmRadioButtonGroup from './forms/OmRadioButtonGroup';
import WhatsAppBubble from './WhatsappChat';

const FindAnAdvisor = ({ findAnAdvisorContent, slot }) => {
    const theme = React.useContext(ThemeContext);

    let dispatch = useDispatch();
    const { assistanceType, chosenLat, chosenLong, testedLocationStatus, discussionOptionsSelected } = useSelector(
        createStructuredSelector({
            searchCriteria: getSearchCriteria,
            assistanceType: getAssistanceType,
            chosenLat: getChosenLat,
            chosenLong: getChosenLong,
            testedLocationStatus: getTestedLocationStatus,
            locationEnabled: getLocationEnabled,
            locationType: getLocationType,
            discussionOptionsSelected: getDiscussionOptionsSelected,
        })
    );

    if (!findAnAdvisorContent) {
        return '';
    }

    let destinationUrl;

    const preferredCommunicationMethods = [
        { value: 'telephonic', description: 'telephonically' },
        //{ value: 'video-call', description: 'video call' }, Removed Video Call Radio button
        { value: 'face-to-face', description: 'face to face' },
        { value: 'virtual-adviser', description: 'virtual' }, // added additional selection
    ];

    function updateLocationField(place) {
        if (place.geometry.location) {
            dispatch(setChosenLongValue(place.geometry.location.lng()));
            dispatch(setChosenLatValue(place.geometry.location.lat()));
        }
    }

    function updateAssistanceField(updatedField) {
        if ((updatedField.detail === 'face-to-face' || updatedField.detail === 'video-call') && !testedLocationStatus) {
            dispatch(setTestedLocationStatusValue(true));
            checkIfPermissionsEnabled();
        }
        updateAssistanceType(updatedField.detail);
    }

    function updateAssistanceType(assistanceType) {
        dispatch(setAssistanceTypeValue(assistanceType));
        dispatch(setLocationTypeValue('other'));
    }

    function checkIfPermissionsEnabled() {
        if (navigator.geolocation) {
            if (navigator.permissions) {
                navigator.permissions.query({ name: 'geolocation' }).then((res) => {
                    if (res.state === 'denied') {
                        updateLocationEnabled(false);
                        navigator.geolocation.getCurrentPosition(
                            () => {},
                            () => {}
                        );
                    } else
                        navigator.geolocation.getCurrentPosition(
                            () => {
                                updateLocationEnabled(true);
                            },
                            () => {
                                updateLocationEnabled(false);
                            }
                        );
                });
            } else
                navigator.geolocation.getCurrentPosition(
                    () => {
                        updateLocationEnabled(true);
                    },
                    () => {
                        updateLocationEnabled(false);
                    }
                );
        } else updateLocationEnabled(false);
    }

    function updateLocationEnabled(status) {
        dispatch(setLocationEnabledValue(status));
    }

    function needsLocation() {
        return assistanceType === 'face-to-face' || assistanceType === 'video-call';
    }

    function addOrRemove(array, item) {
        const exists = array.includes(item.name);

        if (!item.isChecked && exists) {
            // removes
            return array.filter((c) => {
                return c !== item.name;
            });
        } else {
            // adds
            const result = array;
            result.push(item.name);
            return result;
        }
    }

    function updateDiscussOptions(item) {
        let newArray = addOrRemove(discussionOptionsSelected.value, item);
        dispatch(setDiscussionOptionsSelectedValue(newArray));
    }

    function btnDisabled() {
        let locationSatisfied =
            assistanceType === 'telephonic' ||
            assistanceType === 'virtual-adviser' ||
            (chosenLat !== null && chosenLong !== null); //working added virtual adviser line 146
        let hasSelectedDiscussOptions = discussionOptionsSelected.value.length > 0;
        return !(locationSatisfied && hasSelectedDiscussOptions);
    }

    function setUrl() {
        const personalResultsUrl = '/personal/find-adviser/results';
        const wealthResultsUrl = '/wealth/find-adviser/results';
        let setUrl = personalResultsUrl;
        if (theme.includes('wealth')) {
            setUrl = wealthResultsUrl;
        }
        destinationUrl = setUrl;
    }

    function redirect() {
        setUrl();
        let optionsSelected = discussionOptionsSelected.value.map((i) => '&optionsSelected=' + i).join('');
        let queryParams = '';

        if (chosenLat !== null && chosenLong !== null) {
            queryParams = `?assistanceType=${assistanceType}&lat=${chosenLat}&long=${chosenLong}${optionsSelected}`;
        } else {
            queryParams = `?assistanceType=${assistanceType}${optionsSelected}`;
        }

        if (
            assistanceType &&
            discussionOptionsSelected &&
            discussionOptionsSelected.value &&
            discussionOptionsSelected.value.length > 0
        ) {
            window.location.href = destinationUrl + queryParams;
        }
    }

    return (
        <OmFindAnAdviser slot={slot}>
            {assistanceType === 'virtual-adviser' && <WhatsAppBubble />}

            <ul slot="search-fields">
                <li>
                    <label> I want a financial adviser to assist me </label>
                    <OmRadioButtonGroup
                        value={assistanceType}
                        vertical={false}
                        onSelectionHandler={(val) => updateAssistanceField(val)}
                    >
                        {preferredCommunicationMethods.map((communicationMethod, index) => {
                            return (
                                <li key={index} value={communicationMethod.value}>
                                    {communicationMethod.description}
                                </li>
                            );
                        })}
                    </OmRadioButtonGroup>
                </li>
                {needsLocation() && (
                    <li>
                        <label> I live in </label>
                        <Autocomplete
                            className="google-input-field"
                            apiKey="AIzaSyCthYH8ic8qkKpPbfHYjsZOvZ1kPp-Ee6Q"
                            onPlaceSelected={(place) => {
                                updateLocationField(place);
                            }}
                            types={['geocode']}
                        />
                    </li>
                )}
            </ul>
            <div slot="discuss-options">
                <label>I would like to discuss </label>
                <OmCheckBox
                    fieldId="saving"
                    text="saving and investing"
                    value="savingandinvesting"
                    type="discuss"
                    hasIcon={true}
                    onOnCheckBoxChanged={(event) => updateDiscussOptions({ name: 'saving', isChecked: event })}
                />
                <OmCheckBox
                    fieldId="retirement"
                    text="retirement"
                    value="retirement"
                    type="discuss"
                    hasIcon={true}
                    onOnCheckBoxChanged={(event) => updateDiscussOptions({ name: 'retirement', isChecked: event })}
                />
                <OmCheckBox
                    fieldId="education"
                    text="education"
                    value="education"
                    type="discuss"
                    hasIcon={true}
                    onOnCheckBoxChanged={(event) => updateDiscussOptions({ name: 'education', isChecked: event })}
                />
                <OmCheckBox
                    fieldId="lifeCover"
                    text="life cover or insurance"
                    value="lifeCover"
                    type="discuss"
                    hasIcon={true}
                    onOnCheckBoxChanged={(event) => updateDiscussOptions({ name: 'lifeCover', isChecked: event })}
                />
                <OmCheckBox
                    fieldId="funeralCover"
                    text="funeral cover"
                    value="funeralCover"
                    type="discuss"
                    hasIcon={true}
                    onOnCheckBoxChanged={(event) => updateDiscussOptions({ name: 'funeralCover', isChecked: event })}
                />
                <OmCheckBox
                    fieldId="finPlanning"
                    text="financial planning"
                    value="finPlanning"
                    type="discuss"
                    hasIcon={true}
                    onOnCheckBoxChanged={(event) => updateDiscussOptions({ name: 'finPlanning', isChecked: event })}
                />
                <OmCheckBox
                    fieldId="other"
                    text="other"
                    value="other"
                    type="other"
                    hasIcon={true}
                    onOnCheckBoxChanged={(event) => updateDiscussOptions({ name: 'other', isChecked: event })}
                />
            </div>
            <div slot="search-button">
                <OmButton
                    type="primary"
                    size="small"
                    text="FIND AN ADVISER"
                    disabled={btnDisabled()}
                    onClick={redirect}
                />
            </div>
        </OmFindAnAdviser>
    );
};

export default FindAnAdvisor;
